import { render, staticRenderFns } from "./SkinPricingEntriesMultiFetchButton.vue?vue&type=template&id=80c90a8c&scoped=true&"
import script from "./SkinPricingEntriesMultiFetchButton.vue?vue&type=script&lang=ts&"
export * from "./SkinPricingEntriesMultiFetchButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c90a8c",
  null
  
)

export default component.exports